<template>
  <section class="carnival-2020-container" v-pv>
    <main-kv
      v-if="cardList && cardList.length > 0"
      :nav-lists="navLists"
      :video="video"
      :pic-list="cardList"
      :notice="notice"
    />
    <div class="carnival-wrapper">
      <city-tab v-if="cityList && cityList.length > 0" :id="id" :cityList="cityList" @getCityInfo="getCityInfo" />
      <div v-if="cityInfo.banner" class="city-panel-container" data-anchor="CITY">
        <city-panel
          :banner="cityInfo.banner"
          :video-list="cityInfo.videoList"
          :card-list="cityInfo.webcardList"
          :jump-card="cityInfo.jumpCard"
          :key="timer"
        />
      </div>
      <city-info
        v-if="!!carnival"
        :module="{
          title: '漫展',
          name: 'carnival-module',
          en: 'ACGN CONVENTION',
          guests: 1,
          position: 2,
          segment: 3,
          address: 4,
        }"
        :data="carnival"
        :city-name="cityName"
        data-anchor="ACG_CONVENTION"
      />
      <city-info
        v-if="!!concert && navLists && navLists.length > 0 && navLists.some(item => item.value === 'IP')"
        :module="{
          title: '演唱会',
          name: 'concert-module',
          en: 'ACGN CONCERT',
          guests: 1,
          segment: 2,
        }"
        :data="concert"
        data-anchor="CONCERT"
      />
      <banner-info
        data-anchor="IP"
        v-if="navLists && navLists.length > 0 && navLists.some(item => item.value === 'IP')"
      />
      <more-info v-if="moreInfo && moreInfo.bd" :more-info="moreInfo" />
      <footer-info
        v-if="explainDesc !== ''"
        :qa-list="qaList"
        :explain-desc="explainDesc"
        :cooperate-img="cooperateImg"
      />
    </div>
  </section>
</template>
<script>
import http from '@/utils/http'
import { initPingback } from '@iqiyi-h5act/act-pingSdk'
import MainKv from './main-kv/index.vue'
import CityTab from './module/city-tab.vue'
import CityPanel from './module/city-panel.vue'
import CityInfo from './module/city-info.vue'
import BannerInfo from './module/banner.vue'
import MoreInfo from './module/more-info.vue'
import FooterInfo from './module/footer-info.vue'

export default {
  components: {
    MainKv,
    CityTab,
    CityPanel,
    CityInfo,
    BannerInfo,
    MoreInfo,
    FooterInfo,
  },
  data() {
    return {
      navLists: [],
      video: {}, // 爱奇艺视频
      cardList: [], // 爱奇艺轮播图
      notice: '', // 公告
      cityList: [], // 城市列表
      id: '', // 当前城市id
      cityName: '', // 当前城市
      cityInfo: {}, // 当前城市数据
      carnival: {}, // 漫画数据
      concert: {}, // 演唱会数据
      moreInfo: {}, // 更多
      cooperateImg: '',
      explainDesc: '',
      qaList: '',
      isLoading: false,
      timer: '',
    }
  },
  methods: {
    getCityData(city) {
      this.cityInfo = city
      if (city) {
        const { id = '', cityName = '', carnival = {}, concert = {}, webmore = {} } = city
        this.id = id
        this.cityName = cityName
        // 兼容演唱会无数据展示空
        this.concert = concert || {}
        this.carnival = carnival || {}
        if (webmore && webmore.bd) {
          this.moreInfo = webmore
        }
      }
      // 处理Swiper更新问题
      this.timer = new Date().getTime()
    },

    getCarnivalDataFn(cityId) {
      this.isLoading = true
      const getCityInfo = sessionStorage.getItem(`canival-city-${cityId}`)
      // sessionStorage 获取数据
      if (getCityInfo) {
        this.isLoading = false
        const data = JSON.parse(getCityInfo)
        this.getCityData(data)
      } else {
        // cityId 为空 获取所有数据 base + city
        // ciytId 有值 获取城市数据 city
        // const baseurl =
        //   process.env.NODE_ENV === 'production'
        //     ? 'https://manhua-activity.if.iqiyi.com'
        //     : 'https://preview-manhua-activity.if.iqiyi.com'
        const baseurl = 'https://manhua-activity.if.iqiyi.com'
        const params = process.env.NODE_ENV === 'production' ? { cityId } : { cityId, env: '1' }
        http
          .get(`${baseurl}/UserActivity/getCarnivalActivityConfig`, params)
          .then(data => {
            if (!cityId) {
              const {
                NAV_ITEMS = [],
                video = {},
                webcardList = [],
                cityList = [],
                notice = '',
                webmore = {},
                webcooperate = '',
                explainDesc = '',
                qaList = '',
              } = data
              this.navLists = NAV_ITEMS
              this.video = video
              this.cardList = webcardList
              this.cityList = cityList
              this.notice = notice
              this.moreInfo = webmore
              this.cooperateImg = webcooperate
              this.explainDesc = explainDesc
              this.qaList = qaList
            }
            const thisCity = !cityId ? data.city : data
            if (thisCity && thisCity.id) {
              this.getCityData(thisCity)
              sessionStorage.setItem(`canival-city-${thisCity.id}`, JSON.stringify(thisCity))
            }
          })
          .catch(e => {
            if (e.status) {
              this.$message.warning('服务器异常，请稍后再试')
            } else {
              this.$message.warning('当前无网络，请查看网络设置')
            }
          })
      }
    },

    getCityInfo(id) {
      this.id = id
      this.getCarnivalDataFn(id)
      const cityTab = document.querySelector('[data-city-tab="cityTab"]')
      const cityTabHeight = cityTab ? cityTab.offsetHeight : 112
      const navContent = document.querySelector(`[data-anchor="CITY"]`)
      // window 宽度小于 1366 页面缩放75%
      const windowWidth = window.innerWidth
      const scrollHei = navContent.offsetTop - cityTabHeight
      const top = windowWidth > 1366 ? scrollHei : scrollHei * 0.75
      if (navContent) {
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      }
    },
  },
  mounted() {
    initPingback({
      cxid: '1863',
      rpage: 'activity_1863',
    })
    // 初始化获取基础信息 和 城市信息
    this.getCarnivalDataFn()
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
